<ng-container class="spinner-container">
	<div class="page" fxLayout="column" id="top">
		<div fxFlex>
			<div class="container" fxLayout="column" fxLayoutAlign="start">
				<mat-card style="margin: 36px;">
					<mat-card-header>
						<div class="title" translate>お問い合わせ</div>
					</mat-card-header>
					<mat-card-content>
						<div fxLayout="row" fxLayoutAlign="start">
							<button (complete)="onContact($event)" color="warn" contact-button mat-icon-button style="margin: 12px" id="mat-contact-button">
								<mat-icon>question_answer</mat-icon>
							</button>
							<mat-paginator #paginator (page)="Page($event)" [length]="count" [pageSize]="size">
							</mat-paginator>
						</div>
						<mat-selection-list #contacts_list [multiple]="false" style="margin: 24px;">
							<mat-list-option *ngFor="let contact of contacts" [value]="contact" class="mat-elevation-z2" style="font-size:12px;line-height: 14px;font-weight:900;">
								{{toDate(contact.create) | date:"yy/MM/dd HH:mm"}} : {{contact.question | truncate:50}}
							</mat-list-option>
						</mat-selection-list>
						<mat-card>
							<mat-card-content>
								<div fxLayout="row">
									<div>Question:</div>
									<div style="line-height: 14px;margin: 24px;">
										{{contacts_list.selectedOptions.selected[0]?.value.question}}
									</div>
								</div>
								<div fxLayout="row">
									<div>Answer:</div>
									<div style="line-height: 14px;margin: 24px;">
										{{contacts_list.selectedOptions.selected[0]?.value.answer}}
									</div>
								</div>
							</mat-card-content>
						</mat-card>

					</mat-card-content>
				</mat-card>

				<!-- <button mat-icon-button (click)="createDialog()">
					<mat-icon color="accent">question_answer</mat-icon>
				</button> -->
			</div>
		</div>
		<app-footer fxLayout="row" fxLayoutAlign="space-between"></app-footer>
	</div>
</ng-container>
